/**
 * Token storage utility for POC
 * Stores user access token for delegated authentication
 * For production, replace with proper MSAL integration
 */

const TOKEN_STORAGE_KEY = 'fraport_user_access_token';

/**
 * Store user access token
 * @param token - User's Microsoft Graph access token
 */
export const setUserAccessToken = (token: string): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
  }
};

/**
 * Get user access token
 * @returns User's Microsoft Graph access token or null
 */
export const getUserAccessToken = (): string | null => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(TOKEN_STORAGE_KEY);
  }
  return null;
};

/**
 * Clear user access token
 */
export const clearUserAccessToken = (): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
  }
};

/**
 * Check if user access token exists
 * @returns true if token exists
 */
export const hasUserAccessToken = (): boolean => {
  return getUserAccessToken() !== null;
};

